var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mb-4"},[_vm._v("Thank you for the information.")]),_c('v-btn',{attrs:{"disabled":!_vm.token},on:{"click":_vm.changeData}},[_vm._v("Change data")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }